<div class="hero-wrapper">
  <div class="hero-wrapper__inner" [ngStyle]="{backgroundImage: 'url(' + block.data.image_url + ')'}">
    <div class="container-lg">
      <div class="hero-wrapper__content">
        <h1 *ngIf="block.data.text" class="hero-wrapper__header" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></h1>
        <p *ngIf="block.data.bodyText" class="hero-wrapper__text" [innerHTML]="block.data.bodyText"></p>
        <a *ngIf="block.data.buttonText" href="{{block.data.link}}" class="btn btn-primary hero-wrapper__button">{{block.data.buttonText}}</a>
      </div>
    </div>
  </div>
</div>
